import React, { useEffect, useState } from "react";
import "./NewDashboard.scss";
import ClickStatsChart from "../Dashhboard/ClickStatsChart";
import SuperAffiliateSection from "./SuperAffiliate/SuperAffiliateSection";
import CandleChart from "./CandleChart";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { baseUrl } from "../../../Axios";
import ReferList from "./ReferList";
import { FormatUSD } from "../../../utilities/string";
import Loader from "../../../reusableComponents/Loader";
import moment from "moment";
import { DatePicker } from "antd";
import { requestPayout } from "../../../store/reducers/payoutReducer";
import toast from "react-hot-toast";
import { ReactComponent as CheckIcon } from "../../../assets/icons/check-full-green.svg";
const { RangePicker } = DatePicker;

const AffiliateDashboard = () => {
  const { ACCtoken } = useSelector((state) => state);
  const [overviewData, setOverviewData] = useState();
  const [revenueData, setRevenueData] = useState();
  const [loading, setLoading] = useState(false);
  const [paramsValue, setParamsValue] = useState({});
  const [bonusLoading, setBonusLoading] = useState(false);
  const fetchAffiliateOverview = async () => {
    setLoading(true);
    const config = {
      headers: {
        Authorization: ACCtoken,
      },
      params:
        paramsValue?.start_date && paramsValue?.end_date
          ? {
              start_date: moment(paramsValue.start_date).format("DD/MMM/YYYY"),
              end_date: moment(paramsValue.end_date).format("DD/MMM/YYYY"),
            }
          : {},
    };
    try {
      const response = await axios.get(
        `${baseUrl}/affiliate/v2/dashboard/`,
        config
      );

      setOverviewData(response?.data);
    } catch (error) {
      console.error("Error fetching affiliate overview:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchRevenueAndCommission = async () => {
    const config = {
      headers: {
        Authorization: ACCtoken,
      },
      params:
        paramsValue?.start_date && paramsValue?.end_date
          ? {
              start_date: moment(paramsValue.start_date).format("YYYY-MM-DD"),
              end_date: moment(paramsValue.end_date).format("YYYY-MM-DD"),
            }
          : {},
    };
    try {
      const revenueResponse = await axios.get(
        `${baseUrl}/affiliate/v2/commission-vs-revenue/`,
        config
      );
      setRevenueData(revenueResponse.data);
    } catch (error) {
      console.error("Error fetching revenue data:", error);
    }
  };
  useEffect(() => {
    fetchRevenueAndCommission();
  }, [paramsValue]);

  useEffect(() => {
    if (ACCtoken) {
      fetchAffiliateOverview();
    }
  }, [ACCtoken, paramsValue]);

  const dispatch = useDispatch();
  const handleGetbonus = async () => {
    if (bonusLoading) return;
    setBonusLoading(true);
    const payload = {
      amount: overviewData?.bonus_amount,
      type: "Bonus",
    };
    try {
      const response = await dispatch(requestPayout(payload));
      toast.success("Bonus payout requested successfully!");
    } catch (err) {
      toast.error(
        err.detail || "Failed to request bonus payout. Please try again."
      );
    } finally {
      setBonusLoading(false);
    }
  };

  return (
    <div className="newDashboard">
      {<Loader open={loading} />}
      <div className="date-range">
        <RangePicker
          onChange={(dates) => {
            if (dates) {
              setParamsValue({
                start_date: dates[0].format("YYYY-MM-DD"),
                end_date: dates[1].format("YYYY-MM-DD"),
              });
            } else {
              setParamsValue({});
            }
          }}
        />
      </div>
      <div className="date-range date">
        <p>Next withdrawal Date : {overviewData?.next_withdrawal_date}</p>
        {overviewData?.min_withdrawal_amount != null && (
          <p>
            Minimum withdrawal : {FormatUSD(overviewData.min_withdrawal_amount)}
            {overviewData?.withdrawal_interval_days
              ? ` (every ${overviewData.withdrawal_interval_days} days)`
              : ""}
          </p>
        )}
      </div>

      {/* Bonus claim is independent of the tier system that used to wrap it. */}
      {overviewData?.bonus && (
        <div className="affiliate-overview">
          <button
            type="button"
            onClick={handleGetbonus}
            className="get-bonus bonus-check"
            disabled={bonusLoading}
            aria-disabled={bonusLoading}
          >
            {bonusLoading ? (
              <span className="spinner" aria-label="Loading"></span>
            ) : (
              <>
                <span className="bonus-check-icon">
                  <CheckIcon />
                </span>
                <span className="bonus-check-text">Claim Bonus</span>
                {overviewData?.bonus_amount && (
                  <span className="bonus-check-amount">
                    {FormatUSD(overviewData.bonus_amount)}
                  </span>
                )}
              </>
            )}
          </button>
        </div>
      )}

      <SuperAffiliateSection
        superAffiliate={overviewData?.super_affiliate}
        isSuperAffiliate={overviewData?.is_super_affiliate}
        onRefresh={fetchAffiliateOverview}
      />

      <div className="stats">
        <div className="stats-box">
          <p>Total Signup's</p>
          <p>{overviewData?.signups}</p>
        </div>
        <div className="stats-box">
          <p
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            Total Conversions
          </p>
          <p>{overviewData?.conversions}</p>
        </div>
        <div className="stats-box">
          <p>Unique Count</p>
          <p>{overviewData?.unique_count}</p>
        </div>
        <div className="stats-box">
          <p>Pushed Leads</p>
          <p>{overviewData?.pushed_leads ?? 0}</p>
        </div>
        <div className="stats-box">
          <p>Total Revenue Generated</p>
          <p>{FormatUSD(overviewData?.revenue)}</p>
        </div>
        <div className="stats-box">
          <p
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            Total Commission Earned
          </p>
          <p>{FormatUSD(overviewData?.commission_amount)}</p>
        </div>
        <div className="stats-box">
          <p>Till date outstanding commission</p>
          <p>{FormatUSD(overviewData?.outstanding_commission)}</p>
        </div>
        <div className="stats-box">
          <p>Your Affiliate Code Discount</p>
          <p>
            {overviewData?.months_discount_percentage
              ? overviewData?.months_discount_percentage + "%"
              : FormatUSD(overviewData?.months_discount)}
          </p>
        </div>
      </div>
      <div className="chart">
        <ClickStatsChart data={overviewData?.click_stats} />
        <CandleChart data={revenueData} />
      </div>
      <ReferList param={paramsValue} />
    </div>
  );
};

export default AffiliateDashboard;
